module.exports = __webpack_public_path__ + "img/unit8.d681a76a.jpg";